<template>
  <div class="small-ocean">
    <b-container>
    <h1>Games</h1>


    <div v-for="(game,idx) in games" :key="idx" class="card" @click="gameClick(game)">
      <img :src="getImgUrl(game.screenshot)">
      <div class="card-container">
        <h4><strong>{{ game.name }}</strong></h4>
        <p>{{ game.description }}</p>
        
      </div>
      <div class="card-footer">
        
        <h5 class="text-center">
          <div v-if="game.count>1">{{ game.count }} games</div>
          <div v-else>{{ game.count }} game</div>
        </h5>
      </div>
    </div>
  </b-container>
  </div>
</template>

<script>
import games from '../assets/json/games.json'

export default {
  name: 'GamesList',
  props: {
    msg: String
  },
  data() {
    return {
      games: []
    }
  },
  beforeMount(){
    this.games = games.games;
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    gameClick(game){
      console.log("launching "+game.route);
      this.$router.push(game.route);
    },
    getImgUrl(pic) {
      return require('../assets/'+pic);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card {
  width:240px;
  float:left;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.6);
  transition: 0.3s;
  border-radius: 26px;
  margin:15px;
  background-color: #ffffff;
  border: 2px solid black;
}

.card img {
  border-radius: 24px 24px 0 0;
  width:100%;
  min-height:193px;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.8);
  text-decoration: none;
  //border: 2px solid blue;
}

.card-container {
  padding: 2px 16px;
  height:140px;
  overflow:hidden;
}

.card-footer {
  border-top:1px solid black;
}

.ocean {
  background-image:url("../assets/img/world/ocean.jpg");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  min-height:300px;
  margin-top:40px;
  height: 100%;
}
.small-ocean {
  background-image:url("../assets/img/2016/water_banner.png");
  background-size:100% auto;
  background-repeat:no-repeat;
  background-color:#00b7f3;
  margin-top: 0px;
  padding-top: 0px;
  min-height:300px;
  height: 800px;
}
.orange {
  background-color: #FFCC00;
  color: black !important;
}
</style>
